export class UserPreferenceConstants {
  public static readonly DOSearchForShipping = 'DOSearchForShipping';
  public static readonly BookingSearchForShipping = 'BookingSearchForShipping';
  public static readonly BookingSearchForShippingDetail = 'BookingSearchForShippingDetail';
  public static readonly BookingSearchForForwarder = 'BookingSearchForForwarder';
  public static readonly BookingSearchForForwarderDetail = 'BookingSearchForForwarderDetail';
  public static readonly ExportSearch = 'ExportSearch';
  public static readonly ExportDetail = 'ExportDetail';
  public static readonly DOImport = 'DOImport';
  public static readonly DOImportChooseDO = 'DOImportChooseDO';
  public static readonly DOImportSearch = 'DOImportSearch';
  public static readonly DOSearchImport = 'DOSearchImport';
  public static readonly PreviewBooking = 'PreviewBooking';
  public static readonly DOSearchForSales = 'DOSearchForSales';
  public static readonly ContainerManagement = 'ContainerManagement';
  public static readonly RtnDeliveryRemark = 'RtnDeliveryRemark';
  public static readonly RtnDeliveryCnt = 'RtnDeliveryCnt';
  public static readonly RtnWhRemark = 'RtnWhRemark';
  public static readonly UrgentRemark = 'UrgentRemark';
  public static readonly EditBookingDetailSerialPda = 'EditBookingDetailSerialPda';
  public static readonly DoCartonDetailSearch = 'DoCartonDetailSearch';
  public static readonly CustomerChopSignSearch = 'CustomerChopSignSearch';
  public static readonly DoRuleSearch = 'DoRuleSearch';
  public static readonly AddressImport = 'AddressImport';
  public static readonly FlowDoorlaneSearch = 'FlowDoorlaneSearch';
  public static readonly PickingAssignment = 'PickingAssignment';
  public static readonly PickingAssignmentDetail = 'PickingAssignmentDetail';
  public static readonly LeaveWarehouseSearch = 'LeaveWarehouseSearch';
  public static readonly LeaveWarehouseDetailSearch = 'LeaveWarehouseDetailSearch';
  public static readonly OrphanContainerSearch = 'OrphanContainerSearch';
  public static readonly BookingDetailStatusChange = 'BookingDetailStatusChange';
  public static readonly OrphanContainerDetailSearch = 'OrphanContainerDetailSearch';
  public static readonly ImportSearch = 'ImportSearch';
  public static readonly ImportDetail = 'ImportDetail';
  public static readonly TariffRateSetting = 'TariffRateSetting';
  public static readonly CreateWarehousing = 'CreateWarehousing';
  public static readonly WarehousingSearchMain = 'WarehousingSearchMain';
  public static readonly WarehousingSearchDetail = 'WarehousingSearchDetail';
  public static readonly RfqSettingSearchMain = 'RfqSettingSearchMain';
  public static readonly AirwaysExpenseSetting = 'AirwaysExpenseSetting';
  public static readonly RfqSettingSearchDetail = 'RfqSettingSearchDetail';
  public static readonly AirwaysExpenseSettingImport = 'AirwaysExpenseSettingImport';
  public static readonly TariffRateSettingImport = 'TariffRateSettingImport';
  public static readonly DailyRateSetting = 'DailyRateSetting';
  public static readonly DailyRateSettingImport = 'DailyRateSettingImport';
  public static readonly WarehousingRMBPriceImport = 'WarehousingRMBPriceImport';
  public static readonly BatchUpdateBooking = 'BatchUpdateBooking';
  public static readonly EvidenceCheck = 'EvidenceCheck';
  public static readonly ImportDeclarationFeeAccountingReport = 'ImportDeclarationFeeAccountingReport';
  public static readonly ImportExportLicenceInfo = 'ImportExportLicenceInfo';
  public static readonly InOutWarehousingSearchMain = 'InOutWarehousingSearchMain';
  public static readonly InOutWarehousingSearchDetail = 'InOutWarehousingSearchDetail';
  public static readonly MergeKeySearch = 'MergeKeySearch';
  public static readonly ShipmentProgressSearchResult = 'ShipmentProgressSearchResult';
  public static readonly PurchaseSearchResult = 'PurchaseSearchResult';
  public static readonly ShipmentProgress = 'ShipmentProgress';
  public static readonly DoMergeSearch = 'DoMergeSearch';
  public static readonly FreightTrialCalculation = 'FreightTrialCalculation';
  public static readonly MergeKeySearchDetail = 'MergeKeySearchDetail';
  public static readonly InboundProgress = 'InboundProgress';
  public static readonly MergeDoPreview = 'MergeDoPreview';
  public static readonly FreightSearch = 'FreightSearch';
  public static readonly DHLCityMaintenanceTableData = 'DHLCityMaintenanceTableData';
  public static readonly ReceivingInstructionResponse = 'ReceivingInstructionResponse';
  public static readonly ReceivingInstructionDetailResponse = 'ReceivingInstructionDetailResponse';
  public static readonly AdvisingAbnormalTableHeaderData = 'AdvisingAbnormalTableHeaderData';
  public static readonly AdvisingAbnormalTableDetailData = 'AdvisingAbnormalTableDetailData';
  public static readonly AdvisingAbnormalTableAbnormalItemData = 'AdvisingAbnormalTableAbnormalItemData';
  public static readonly DOAbnormalTableHeaderData = 'DOAbnormalTableHeaderData';
  public static readonly DOAbnormalTableDetailData = 'DOAbnormalTableDetailData';
  public static readonly DOAbnormalTableAbnormalItemData = 'DOAbnormalTableAbnormalItemData';
  public static readonly CustomerSignatureSampleStampResponse = 'CustomerSignatureSampleStampResponse';
  public static readonly AnnouncementTableResponse = 'AnnouncementTableResponse';
  public static readonly ForwarderCooperationResponse = 'ForwarderCooperationResponse';
  public static readonly AddressMaintainTableHeaderData = 'AddressMaintainTableHeaderData';
  public static readonly AddressMaintainTableDetailData = 'AddressMaintainTableDetailData';
  public static readonly AddressMaintainTableImportData = 'AddressMaintainTableImportData';
  public static readonly TenantMappingUserGroupDetailTableData = 'TenantMappingUserGroupDetailTableData';
  public static readonly UserGroupSubscriptionTableData = 'UserGroupSubscriptionTableData';
  public static readonly AutoPrintSettingTableHeaderData = 'AutoPrintSettingTableHeaderData';
  public static readonly AutoPrintSettingTableDetailData = 'AutoPrintSettingTableDetailData';
  public static readonly FacilityPrinterData = 'FacilityPrinterData';
  public static readonly BellNotificationsTableData = 'BellNotificationsTableData';
  public static readonly BookingDetailPickUpStatusChange = 'BookingDetailPickUpStatusChange';
  public static readonly PurchaseSearchResult2 = 'PurchaseSearchResult2';
  public static readonly MSDCIQC = 'MSDCIQC';
  public static readonly MSDCSearch = 'MSDCSearch';
  public static readonly ManualAllocationMO = 'ManualAllocationMO';
  public static readonly ManualAllocationMODetail = 'ManualAllocationMODetail';
  public static readonly ManualAllocationAllocated = 'ManualAllocationAllocated';
  public static readonly ManualAllocationAvailable = 'ManualAllocationAvailable';
  public static readonly HawbNoDataOfWarehousingAbnormal = 'HawbNoDataOfWarehousingAbnormal';
  public static readonly WarehousingHeaderDataOfWarehousingAbnormal = 'WarehousingHeaderDataOfWarehousingAbnormal';
  public static readonly WarehousingAbnormalHeaderData = 'WarehousingAbnormalHeaderData';
  public static readonly WarehousingAbnormalDetailData = 'WarehousingAbnormalDetailData';
  public static readonly AdvisingHeaderDataOfWarehousingAbnormal = 'AdvisingHeaderDataOfWarehousingAbnormal';
  public static readonly AdvisingDetailDataOfWarehousingAbnormal = 'AdvisingDetailDataOfWarehousingAbnormal';
  public static readonly StockSKUSearch = 'StockSKUSearch';
  public static readonly CreateMoItemTableData = 'CreateMoItemTableData';
  public static readonly EnvironmentMonitorTableData = 'EnvironmentMonitorTableData';
  public static readonly PurchaseSearchCreateAd = 'PurchaseSearchCreateAd';
  public static readonly MSDCSearchColumnOrder = 'MSDCSearchColumnOrder';
  public static readonly StockInfoSearch = 'StockInfoSearch';
  public static readonly CustomsClearanceShippingReportHeaderTableData = 'CustomsClearanceShippingReportHeaderTableData';
  public static readonly CustomsClearanceShippingReportDetailTableData = 'CustomsClearanceShippingReportDetailTableData';
  public static readonly VMIAdvisingSearchTable = 'VMIAdvisingSearchTable';
  public static readonly VMIAdvisingSearchTableDetail = 'VMIAdvisingSearchTableDetail';
  public static readonly VMIDOCreateSearchTable = 'VMIDOCreateSearchTable';
  public static readonly VMIDOCreateSearchTableDetail = 'VMIDOCreateSearchTableDetail';
  public static readonly ForwarderSetting = 'ForwarderSetting';
  public static readonly RMBForwarderSetting = 'RMBForwarderSetting';
  public static readonly TruckCostAllocation = 'TruckCostAllocation';
  public static readonly InOutReport = 'InOutReport';
  public static readonly SpecialInventoryControl = 'SpecialInventoryControl';
  public static readonly PurgeControl = 'PurgeControl';
  public static readonly CustomerReferencPreference = 'CustomerReferencPreference';
  public static readonly PurgeInventoryPreference = 'PurgeInventoryPreference';
  public static readonly PurgeConditionPreference = 'PurgeConditionPreference';
  public static readonly PlantTransferSearchTable = 'PlantTransferSearchTable';
  public static readonly PlantTransferSearchTableDetail = 'PlantTransferSearchTableDetail';
  public static readonly PlantTransferUploadTable = 'PlantTransferUploadTable';
  public static readonly PlantTransferUploadTableDetail = 'PlantTransferUploadTableDetail';
  public static readonly CustomerLabelHeaderMaintenance = 'CustomerLabelHeaderMaintenance';
  public static readonly CustomerLabelDetailMaintenance = 'CustomerLabelDetailMaintenance';
  public static readonly UrgentNoPreferenceKey = 'UrgentNoPreferenceKey';
  public static readonly InvUploadHeader = 'InvUploadHeader';
  public static readonly FacilityOptionMaintenance = 'FacilityOptionMaintenance';
}
